import { z } from 'zod';

import { AccountIdSchema } from './account';

export const DisciplineCycleStatusSchema = z.enum(['NORMAL', 'PROTECT_PROFITS', 'DE_RISK']);

export const DisciplineCycleQuerySchema = z.object({
  accountId: AccountIdSchema,
});

export const ResetDisciplineCycleSchema = z.object({
  accountId: AccountIdSchema,
  snapshotId: z.string().trim().min(1, 'Snapshot is required.'),
});

export type DisciplineCycleStatus = z.infer<typeof DisciplineCycleStatusSchema>;
export type DisciplineCycleQuery = z.infer<typeof DisciplineCycleQuerySchema>;
export type ResetDisciplineCycleInput = z.infer<typeof ResetDisciplineCycleSchema>;

export interface DisciplineCycleDto {
  id: string;
  accountId: string;
  status: DisciplineCycleStatus;
  resetNav: string;
  resetDate: string;
  currentNav: string;
  cashFlowAdjustedNav: string;
  netExternalCashFlow: string;
  currentDate: string;
  highWaterNav: string;
  highWaterDate: string;
  peakProfit: string;
  currentGiveback: string;
  givebackPctOfPeak: string;
  protectionActivated: boolean;
  activationProfitNav: string;
  protectThresholdNav: string;
  deriskThresholdNav: string;
  deriskTargetGrossPct: string;
  activatedAt: string | null;
  updatedAt: string;
}
